define.alias("shared/components/shared/social/instagram-upgrade/banner", "media/components/shared/social/instagram-upgrade/banner");